import React, { useState } from "react";
import toast from "react-hot-toast";
import { createNewsletterSubscription } from "../../../api/newletter.service";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.dismiss();toast.error("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.dismiss();toast.error("Please enter a valid email address");
      return;
    }

    setIsSubmitting(true);
    
    try {
      const response = await createNewsletterSubscription({ email });
      
      if (response.success) {
        toast.dismiss();toast.success(response.message || "Successfully subscribed to newsletter!");
        setEmail("");
      } else {
        toast.dismiss();toast.error(response.message || "Failed to subscribe. Please try again.");
      }
    } catch (error) {
      toast.dismiss();toast.error("An error occurred. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <section className='flex flex-wrap container mx-auto gap-10 justify-center items-center px-8 md:py-6 py-3 mt-16 text-white rounded-t-xl lg:m-auto bg-[#293A5F] max-md:flex-col max-md:items-center max-md:gap-2 max-md:px-4 max-md:mt-10 '>
      <div className='flex flex-col justify-center text-center min-w-[240px] max-md:w-full max-md:mx-auto max-md:my-1'>
        <h2 className='text-2xl font-medium text-left max-md:text-xl max-md:text-center'>
          Need more information?
        </h2>
        <p className='mt-2.5 max-md:text-sm max-md:mt-1'>
          Write your concern to us, and our specialist will get back to you.
        </p>
      </div>

      <form className='flex flex-col text-xl rounded-xl md:min-w-[340px] min-w-[320px] max-md:w-full max-md:text-base max-md:mx-auto max-md:my-3'>
        <label htmlFor='emailInput' className='sr-only'>
          Enter Email Address
        </label>
        <input
          id='emailInput'
          type='email'

          placeholder='Enter Email Address'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
          className='px-4 py-3 rounded-xl border border-white border-solid bg-zinc-300 bg-opacity-0 max-md:py-3'
          aria-label='Enter Email Address'
        />
      </form>

      <button
        type='submit'
        className={`px-2 py-4 md:text-xl text-lg rounded-lg font-semibold whitespace-nowrap bg-[#7AB2D3] w-[50%] md:w-[160px] max-md:text-base max-md:py-3 max-md:mx-auto max-md:my-1 ${
          isSubmitting
            ? 'opacity-70 cursor-not-allowed'
            : 'hover:bg-[#6491AD] transition-colors'
        }`}
        onClick={handleSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Subscribing...' : 'Subscribe'}
      </button>
    </section>
  );
}

export default Newsletter;
